import { createTransport } from '@sentry/react';
import type { BaseTransportOptions, Transport, TransportRequest } from '@sentry/types';

export function createLocalTransport(options: BaseTransportOptions): Transport {
  const executeRequest = (request: TransportRequest) => {
    if (import.meta.env.APP_LOG_SENTRY_EVENTS) {
      const jsonStrings = (request.body as string).trim().split('\n');
      const destructuredBody = jsonStrings.reduce((result, part) => {
        return {
          // biome-ignore lint/performance/noAccumulatingSpread: TODO: improve performance
          ...result,
          ...JSON.parse(part),
        };
      }, {});

      console.info(
        `[SENTRY ${((destructuredBody as { type?: string })?.type || '').toUpperCase()} EVENT]: `,
        destructuredBody,
      );
    }

    return Promise.resolve({
      statusCode: 200,
    });
  };

  return createTransport(options, executeRequest);
}
